// extracted by mini-css-extract-plugin
export var spinner = "loading-module--spinner--df97d";